var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "container nsw-container mb-5" }, [
    _c("div", { staticClass: "nsw-content-wrapper renewal-content-wrapper" }, [
      _vm.step === 5
        ? _c("h1", [_vm._v("Thank you for your continued support")])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sections-wrapper" },
        [
          _vm.pageStatus === "loading"
            ? _c("el-skeleton", { attrs: { rows: 6, animated: "" } })
            : _vm._e(),
          _vm._v(" "),
          _vm.pageStatus === "error"
            ? _c("el-empty", {
                attrs: {
                  description:
                    "An error has occurred and we're unable to process your renewal",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pageStatus === "pending-payment"
            ? _c("el-alert", {
                attrs: {
                  title:
                    "A pending payment for dues already exists for this membership",
                  type: "info",
                  "show-icon": "",
                  center: "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pageStatus === "renewed-already"
            ? _c(
                "el-result",
                [
                  _c("template", { slot: "icon" }, [_c("div")]),
                  _vm._v(" "),
                  _c("template", { slot: "extra" }, [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.configSettings["renewal-already-paid"]
                        ),
                      },
                    }),
                  ]),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.pageStatus === "success"
            ? [
                _vm.step < 5 ? _c("renewal-step") : _vm._e(),
                _vm._v(" "),
                _vm.step === 1 ? _c("renewal-membership") : _vm._e(),
                _vm._v(" "),
                _vm.step === 2 ? _c("renewal-donation") : _vm._e(),
                _vm._v(" "),
                _vm.step === 3 ? _c("renewal-detail") : _vm._e(),
                _vm._v(" "),
                _vm.step === 4 ? _c("renewal-payment") : _vm._e(),
                _vm._v(" "),
                _vm.step === 5 ? _c("renewal-receipt") : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }